/* If America Were Great: helpers for the ported sections (pack builder, quick add,
   "finish the sentence" rotator, email confirmations). Adds go through Creative's
   cart store when it is available so the cart drawer and count update. */
(function () {
  'use strict';
  var IAWG = window.IAWG = window.IAWG || {};

  function creativeStore() {
    return window.theme && window.theme.cart && window.theme.cart.store;
  }

  function plainAdd(items) {
    var url = (IAWG.routes && IAWG.routes.cart_add) || '/cart/add';
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    });
  }

  IAWG.addItems = function (items) {
    var store = creativeStore();
    if (store && store.getState && store.getState().add) {
      return store.getState().add(items);
    }
    return plainAdd(items);
  };

  /* Quick add on product cards */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.iawg form[data-quick-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var id = parseInt(form.querySelector('input[name="id"]').value, 10);
    var qty = parseInt((form.querySelector('input[name="quantity"]') || {}).value || '1', 10);
    var item = { id: id, quantity: qty };
    var props = {};
    form.querySelectorAll('input[name^="properties["]').forEach(function (p) {
      if (p.value) props[p.name.slice(11, -1)] = p.value;
    });
    if (Object.keys(props).length) item.properties = props;
    if (btn) { btn.classList.add('is-busy'); btn.textContent = 'Adding…'; }
    IAWG.addItems([item]).then(function () {
      if (!btn) return;
      btn.classList.remove('is-busy'); btn.classList.add('is-done');
      btn.textContent = btn.getAttribute('data-added') || 'Added';
      setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = btn.getAttribute('data-label') || 'Add to cart'; }, 1800);
    }).catch(function (err) {
      if (!btn) return;
      btn.classList.remove('is-busy');
      btn.textContent = (err && err.message) ? err.message : 'Try again';
      setTimeout(function () { btn.textContent = btn.getAttribute('data-label') || 'Add to cart'; }, 2500);
    });
  });

  function initRotators(scope) {
    (scope || document).querySelectorAll('.iawg [data-rotator]').forEach(function (wrap) {
      if (wrap.getAttribute('data-ready')) return;
      wrap.setAttribute('data-ready', '1');
      var rotator = wrap.querySelector('.sentence__rotate');
      var dots = wrap.querySelector('.sentence__dots');
      var lines = [];
      try { lines = JSON.parse(wrap.getAttribute('data-lines') || '[]'); } catch (e) {}
      lines = lines.map(function (l) { return (l || '').trim(); }).filter(Boolean);
      if (!rotator || !dots || lines.length < 2) return;
      dots.innerHTML = '';
      lines.forEach(function (_, i) {
        var d = document.createElement('i');
        if (i === 0) d.classList.add('on');
        dots.appendChild(d);
      });
      rotator.textContent = lines[0];
      var idx = 0;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = parseInt(wrap.getAttribute('data-interval') || '2500', 10);
      setInterval(function () {
        idx = (idx + 1) % lines.length;
        var swap = function () {
          rotator.textContent = lines[idx];
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === idx); });
          rotator.classList.remove('is-out');
        };
        if (reduced) { swap(); return; }
        rotator.classList.add('is-out');
        setTimeout(swap, 350);
      }, interval);
    });
  }

  function initEmailOk() {
    var params = new URLSearchParams(location.search);
    if (params.get('customer_posted') !== 'true') return;
    document.querySelectorAll('.iawg [data-email-form]').forEach(function (f) {
      var ok = f.parentElement.querySelector('[data-email-ok]');
      if (ok) { f.style.display = 'none'; ok.hidden = false; }
    });
    var target = document.querySelector('.iawg [data-email-ok]:not([hidden])');
    if (target) target.scrollIntoView({ block: 'center' });
  }

  function init() { initRotators(); initEmailOk(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initRotators(e.target); });
})();
